const nonOperationStates = ['NY'];

export default nonOperationStates;